import { useApi } from '@/shared/api/http';
import { FAVORITE_TYPE_LAWYER } from '@/shared/constants/favoriteConstants';
import type { IGetFavoritesParams } from '@/entities/favorite/model/types';

export const useFavoriteService = () => {
  const api = useApi();

  const addToFavorite = async (lawyerId: number, type: number = FAVORITE_TYPE_LAWYER) => {
    return await api.post('favorites', { entity_id: lawyerId, type });
  };

  const deleteFromFavorite = async (
    lawyerId: number,
    type: number = FAVORITE_TYPE_LAWYER,
  ) => {
    return await api.delete(`favorites/${lawyerId}/${type}`);
  };

  const getAllFavorites = async (params: IGetFavoritesParams) => {
    return await api.get('favorites/', { params: { ...params } });
  };

  return {
    addToFavorite,
    deleteFromFavorite,
    getAllFavorites,
  };
};
